import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SEO_COPY } from "@/data/seoCopy";

const Rich = ({ text }) => text.split(/(\*\*[^*]+\*\*)/).map((part, i) =>
  part.startsWith("**") ? <strong key={i} className="text-[var(--text)] font-semibold">{part.slice(2, -2)}</strong> : part
);

export const SeoCopyBlock = ({ id, source }) => {
  const c = SEO_COPY[id];
  if (!c) return null;
  return (
    <section data-testid={`seo-copy-${id}`} className="py-20">
      <div className="shg-container grid lg:grid-cols-[1.4fr_1fr] gap-12 items-start">
        <div>
          <h2 className="font-display text-3xl md:text-4xl leading-tight mb-6">{c.h2}</h2>
          {c.paragraphs.map((p, i) => <p key={i} className="text-[var(--text-soft)] text-base md:text-lg leading-relaxed mb-5"><Rich text={p} /></p>)}
          {c.bullets && (
            <>
              <h3 className="font-display text-xl mt-8 mb-4">{c.listTitle}</h3>
              <ul className="space-y-3">{c.bullets.map((b) => <li key={b} className="flex gap-3"><Check size={18} className="text-[var(--red)] mt-1 flex-shrink-0" /><span className="text-[var(--text-soft)]">{b}</span></li>)}</ul>
            </>
          )}
        </div>
        <aside data-testid={`seo-copy-cta-${id}`} className="rounded-2xl p-8 lg:sticky lg:top-28" style={{ background: "var(--surface)", border: "1px solid var(--line-strong)" }}>
          <div className="shg-eyebrow mb-3">Free 3D design</div>
          <h3 className="font-display text-2xl mb-3">{c.ctaTitle}</h3>
          <p className="text-[var(--text-soft)] text-sm leading-relaxed mb-6">{c.ctaText}</p>
          <Link to={`/contact?source=${source || id}`} data-testid={`seo-copy-cta-btn-${id}`} className="btn-primary">{c.ctaButton} <ArrowUpRight size={16} /></Link>
        </aside>
      </div>
    </section>
  );
};

export default SeoCopyBlock;
